import { Text } from '@chakra-ui/react';
import dayjs from 'dayjs';
import * as React from 'react';

import { MembershipTermLifecycleStatus } from '@/graphql-types/globalTypes';

export const TimelineHeader: React.FC<{
  startDate: string;
  lifecycleStatus: MembershipTermLifecycleStatus;
}> = ({ startDate, lifecycleStatus }) => {
  const now = dayjs();
  const numDays = Math.abs(Math.round(now.diff(startDate, 'days', false)));

  const header =
    lifecycleStatus === MembershipTermLifecycleStatus.IMPENDING
      ? `STARTS IN ${numDays} ${numDays === 1 ? 'DAY' : 'DAYS'}`
      : lifecycleStatus === MembershipTermLifecycleStatus.EXPIRED
      ? 'PAST'
      : 'CURRENT';

  return (
    <Text textStyle="detailStrong" color="gray.500">
      {header}
    </Text>
  );
};
